import { useQuery } from "@tanstack/react-query";

import { getEmail } from "@/api/emails";

export function useEmailDetail(id: string | null) {
  return useQuery({
    queryKey: ["email", id],
    queryFn: () => getEmail(id as string),
    enabled: id !== null,
  });
}
